const SERVICE_DATA = {
  heading: "Our Services",
  description:
    "Achieve balance and harmony in your life with our holistic approach to wellness.",
  services_list: [
    {
      label: "Happiness Program",
      text: " Experience the transformative power of Art of Living's Happiness Program to reduce stress and enhance overall well-being.",
      icon: "pe-7s-arc",
    },
    {
      label: "Yoga Session",
      text: "Find deep relaxation and rejuvenation through our restorative yoga classes, designed to release tension and promote healing.",
      icon: "pe-7s-display2",
    },
    {
      label: "Health and Happiness Workshop",
      text: "Immerse in the practices of meditation, pranayama, and yoga for a more profound experience and understanding.",
      icon: "pe-7s-piggy",
    },
    {
      label: "Baal Chetana Shivir",
      text: " Introduce your child to the benefits of yoga and meditation through our 5 days free workshop.",
      icon: "pe-7s-science",
    },
    {
      label: "Nawa Chetana Shivir",
      text: "Take the first step towards your yoga, meditation, and wellness journey with our 5-day class.",
      icon: "pe-7s-news-paper",
    },
    {
      label: "Personal Wellness",
      text: "Receive personalized guidance and support to achieve your wellness goals through our expert guidance.",
      icon: "pe-7s-plane",
    },
  ],
};

const FEATURES_DATA = {
  title:
    "Blessed with the spiritual guidance of Gurudev Sri Sri Ravi Shankar, I offer wellness programs for inner peace and joy.",
  text: "As a certified wellness facilitator and enthusiast, my passion lies in promoting a stress-free mind, a disease-free body, and a violence-free society, while striving towards the goal of Vasudhaiva Kutumbakam (the world is one family).",
  feature_list: [
    "Tailored wellness programs and resources to suit your unique needs and goals.",
    "Expert guidance and support to help you cultivate healthy habits and sustainable lifestyle changes.",
    "A compassionate and empathetic approach to wellness, grounded in the principles of mindfulness and self-care.",
    
  ],
};

const PRICING_DATA = {
  title: "Our Pricing",
  description:
    "Call to action pricing table is really crucial to your for your business website. Make your bids stand-out with amazing options.",
  pricing_list: [
    {
      title: "Economy",
      price: "$9.90",
      bandwidth: "1GB",
      space: "50MB",
      support: "No",
      domain: 1,
    },
    {
      title: "Delux",
      price: "$19.90",
      bandwidth: "10GB",
      space: "500MB",
      support: "Yes",
      domain: 10,
    },
    {
      title: "Unlimate",
      price: "$29.90",
      bandwidth: "100GB",
      space: "2 GB",
      support: "Yes",
      domain: "Unlimited",
    },
  ],
};

const TEAM_DATA = {
  title: "Behind The People",
  description:
    "It is a long established fact that create category leading brand experiences a reader will be distracted by the readable content of a page when looking at its layout.",
  team_list: [
    {
      profile: "/images/team/img-1.jpg",
      name: "Frank Johnson",
      designation: "CEO",
    },
    {
      profile: "/images/team/img-2.jpg",
      name: "Elaine Stclair",
      designation: "Designer",
    },
    {
      profile: "/images/team/img-3.jpg",
      name: "Wanda Arthur",
      designation: "Developer",
    },
    {
      profile: "/images/team/img-4.jpg",
      name: "Joshua Stemple",
      designation: "Manager",
    },
  ],
};

const TESATIMONIAL_DATA = {
  title: "What they've said",
  description:
    "The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks and devious pulvinar metus molestie sed Semikoli.",
  testimonial_list: [
    {
      profile: "images/testimonials/user-2.jpg",
      description:
        "I feel confident imposing change on myself. It's a lot more fun progressing than looking back. That's why scelerisque pretium dolor, sit amet vehicula erat pelleque need throw curve balls.",
      name: "Ruben Reed - ",
      text: "Charleston",
    },
    {
      profile: "images/testimonials/user-1.jpg",
      description:
        "Our task must be to free ourselves by widening our circle of compassion to embrace all living creatures Integer varius lacus non magna tempor congue natuasre the whole its beauty.",
      name: "Michael P. Howlett - ",
      text: "Worcester",
    },
    {
      profile: "images/testimonials/user-3.jpg",
      description:
        "I've learned that people will forget what you said, people will forget what you did, but people will never aliquam in nunc quis tincidunt forget how you vestibulum egestas them feel.",
      name: "Theresa D. Sinclair - ",
      text: "Lynchburg",
    },
  ],
};

const BLOG_DATA = {
  title: "Blog",
  description:
    "Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean class at a euismod mus ipsum vel ex finibus semper luctus quam.",
  blog_list: [
    {
      image: "images/blog/img-1.jpg",
      text: "UI & UX Design",
      title: "Doing a cross country road trip",
      subtext:
        "She packed her seven versalia, put her initial into the belt and made herself on the way..",
    },
    {
      image: "images/blog/img-2.jpg",
      text: "Digital Marketing",
      title: "New exhibition at our Museum",
      subtext:
        "Pityful a rethoric question ran over her cheek, then she continued her way.",
    },
    {
      image: "images/blog/img-3.jpg",
      text: "Travelling",
      title: "Why are so many people..",
      subtext:
        "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.",
    },
  ],
};

const MOCK_DATA = {
  SERVICE_DATA,
  FEATURES_DATA,
  PRICING_DATA,
  TEAM_DATA,
  TESATIMONIAL_DATA,
  BLOG_DATA,
};

export default MOCK_DATA;
